var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01345 5.85742C7.36885 6.21282 7.36885 6.78998 7.01345 7.14538L1.55452 12.6043C1.19912 12.9597 0.621949 12.9597 0.26655 12.6043C-0.0888498 12.2489 -0.0888498 11.6718 0.26655 11.3163L5.08292 6.49998L0.269393 1.68361C-0.0860067 1.32821 -0.0860067 0.751038 0.269393 0.395639C0.624792 0.0402395 1.20196 0.0402395 1.55736 0.395639L7.01629 5.85457L7.01345 5.85742Z",
    fill: "#0C0589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.a9877f27ec37045363276cbf81a8340d.svg";
export { ForwardRef as ReactComponent };